import { render, staticRenderFns } from "./FormAssetLabel.vue?vue&type=template&id=14b3b0da&scoped=true"
import script from "./FormAssetLabel.vue?vue&type=script&lang=js"
export * from "./FormAssetLabel.vue?vue&type=script&lang=js"
import style0 from "./FormAssetLabel.vue?vue&type=style&index=0&id=14b3b0da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b3b0da",
  null
  
)

export default component.exports